import { ROUTES } from "./routes"
import { faUser, faUserPlus, faBuildings } from "@fortawesome/pro-light-svg-icons"

export const ORG_TIERS = {
  PROSPECTING_ADVERTISE: "prospecting_advertise",
  ADVERTISE_FREE: "advertise_free",
  ADVERTISE: "advertise"
}

export const ADVERTISE_TIER_CONTENT = {
  disabled: true,
  icon: faUser,
  tierName: "Max",
  description: "Lorem ipsum dolor sit amet consectetur. Ullamcorper in a ac tellus imperdiet integer quam egestas et.",
  includedFeatures: ["Lorem ipsum dolor sit amet consectetur.", "Lorem ipsum dolor sit amet consectetur."],
  missingFeatures: ["Lorem ipsum dolor sit amet consectetur."],
  clickHandler: () => window.location.assign(`${ROUTES.SELFSERVE_SIGNUP}?tier=advertise_free`),
  buttonText: "Sign Up"
}

export const ADVERTISE_PRO_TIER_CONTENT = {
  disabled: true,
  icon: faUserPlus,
  tierName: "Pro",
  description: "Lorem ipsum dolor sit amet consectetur. Ullamcorper in a ac tellus imperdiet integer quam egestas et.",
  includedFeatures: ["Lorem ipsum dolor sit amet consectetur.", "Lorem ipsum dolor sit amet consectetur."],
  missingFeatures: ["Lorem ipsum dolor sit amet consectetur."],
  clickHandler: () => {},
  buttonText: "Sign Up"
}

export const ENTERPRISE_TIER_CONTENT = {
  disabled: true,
  icon: faBuildings,
  tierName: "Enterprise",
  description: "Lorem ipsum dolor sit amet consectetur. Ullamcorper in a ac tellus imperdiet integer quam egestas et.",
  includedFeatures: ["Lorem ipsum dolor sit amet consectetur.", "Lorem ipsum dolor sit amet consectetur."],
  missingFeatures: ["Lorem ipsum dolor sit amet consectetur."],
  clickHandler: () => {},
  buttonText: "Contact Us"
}